// ─── Homepage (/) theme palette ───────────────────────────────────────────
// Warm gradient: cream → terracotta → wine → burgundy, with coral + mint accents.
//   #FBDB93  cream / butter   (primary accent)
//   #BE5B50  terracotta       (secondary accent)
//   #8A2D3B  wine / maroon    (borders)
//   #641B2E  deep burgundy    (deep tones / homepage text)
//   #FF8282  soft coral       (highlight / hard)
//   #DBFFCB  pale mint        (easy / success)
// Fonts: Orbitron (headers), Raleway (body) — matching the techy/editorial mix.

export const THEME = {
  cream:       '#FBDB93',
  creamSoft:   '#F8E8C4',
  terracotta:  '#BE5B50',
  wine:        '#8A2D3B',
  burgundy:    '#641B2E',
  coral:       '#FF8282',
  mint:        '#DBFFCB',

  // Dark scene chrome
  bg:          '#0a0a0a',
  bgDeep:      '#000000',
  panel:       'rgba(15,15,15,0.85)',
  panelSolid:  '#111111',
  panelBorder: 'rgba(255,255,255,0.12)',
  panelBorderStrong: 'rgba(255,255,255,0.25)',

  // Primary accent + text
  accent:      '#FBDB93',
  accentDim:   '#C9A45E',
  text:        '#ffffff',
  dim:         'rgba(255,255,255,0.4)',
  dimmer:      'rgba(255,255,255,0.12)',

  // Back-compat aliases (old code referenced THEME.amber*)
  amber:       '#FBDB93',
  amberDim:    '#C9A45E',
  amberDeep:   '#8A2D3B',
}

// ─── Algorithmic element state colors ────────────────────────────────────
export const STATE_COLORS = {
  inactive: {
    base: '#2E1A1E',
    emissive: '#1A0A0E',
    intensity: 0.18,
    yOffset: 0,
    scale: 1.0,
    opacity: 0.95,
    textColor: '#818798',
  },
  active: {
    base: '#FBDB93',
    emissive: '#C8902A',
    intensity: 0.7,
    yOffset: 0.45,
    scale: 1.14,
    opacity: 1.0,
    textColor: '#080808',
  },
  compared: {
    base: '#E8A020',
    emissive: '#A06010',
    intensity: 0.55,
    yOffset: 0.22,
    scale: 1.07,
    opacity: 1.0,
    textColor: '#080808',
  },
  visited: {
    base: '#3A3A60',
    emissive: '#1A1A40',
    intensity: 0.3,
    yOffset: 0,
    scale: 1.0,
    opacity: 0.8,
    textColor: '#A0A0C0',
  },
  answer: {
    base: '#1A4A2A',
    emissive: '#0A8A3A',
    intensity: 1.0,
    yOffset: 0.55,
    scale: 1.18,
    opacity: 1.0,
    textColor: '#AAFFCC',
  },
  rejected: {
    base: '#4A1A1A',
    emissive: '#AA2222',
    intensity: 0.25,
    yOffset: -0.15,
    scale: 0.9,
    opacity: 0.45,
    textColor: '#FF8888',
  },
  pivot: {
    base: '#4A2A08',
    emissive: '#CC6600',
    intensity: 0.7,
    yOffset: 0.3,
    scale: 1.1,
    opacity: 1.0,
    textColor: '#FFD080',
  },

  // ── Extended states (Tier 1+) ─────────────────────────────────────────────
  processing: {
    base: '#2E1050',
    emissive: '#7A2ABA',
    intensity: 0.6,
    yOffset: 0.3,
    scale: 1.08,
    opacity: 1.0,
    textColor: '#D0A0FF',
  },
  candidate: {
    base: '#5A3A08',
    emissive: '#C07010',
    intensity: 0.65,
    yOffset: 0.35,
    scale: 1.1,
    opacity: 1.0,
    textColor: '#FFD080',
  },
  memoized: {
    base: '#0A3A30',
    emissive: '#0A8060',
    intensity: 0.45,
    yOffset: 0.1,
    scale: 1.02,
    opacity: 0.9,
    textColor: '#80FFD8',
  },
  frontier: {
    base: '#0A2A4A',
    emissive: '#1060A0',
    intensity: 0.5,
    yOffset: 0.15,
    scale: 1.04,
    opacity: 0.95,
    textColor: '#80C8FF',
  },
  pruned: {
    base: '#141414',
    emissive: '#282828',
    intensity: 0.08,
    yOffset: -0.2,
    scale: 0.72,
    opacity: 0.35,
    textColor: '#666666',
  },
  'current-frame': {
    base: '#FBDB93',
    emissive: '#C8902A',
    intensity: 0.85,
    yOffset: 0.5,
    scale: 1.16,
    opacity: 1.0,
    textColor: '#080808',
  },
}
